export default __webpack_public_path__ + "static/media/Logo_TW.87d11b61.png";